<template>
  <div class="addTrainingCourseAdmin">
    <el-page-header
      content="添加基础物料"
      @back="
        $router.push({
          path: '/background/basicMaterial',
        })
      "
    ></el-page-header>

    <!-- 表单 -->
    <el-form
      class="form-style"
      label-width="100px"
      :model="form"
      ref="form"
      :rules="rules"
      size="small"
      label-position="left"
    >
      <el-form-item label="所属科目:">
        <el-select v-model="form.subject_id" clearable filterable placeholder="请选择">
          <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="使用场景:">
        <el-select v-model="form.scene_id" clearable placeholder="请选择">
          <el-option v-for="item in sceneList1" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标题:" required prop="title">
        <el-input
          placeholder="请输入标题"
          clearable
          v-model="form.title"
          maxlength="200"
          show-word-limit
        ></el-input>
      </el-form-item>

      <el-form-item label="简要介绍:" required prop="brief_content">
        <el-input type="textarea" v-model="form.brief_content" maxlength="400" show-word-limit></el-input>
      </el-form-item>

      <el-form-item label="物料说明:" required prop="main_content">
        <MarkDown v-if="showmarkdown" :markdown="form.main_content" @SaveMarkDown="SaveMarkDown"></MarkDown>
      </el-form-item>

      <!-- <el-form-item label="下载地址:" required prop="zip_url">
        <el-input placeholder="请输入下载地址" v-model="form.zip_url"></el-input>
      </el-form-item>-->

      <el-form-item label="* 封面地址">
        <el-upload
          action
          ref="upload"
          :http-request="uploadFile"
          :on-remove="handleRemove"
          :on-change="handleChangeFile"
          :auto-upload="false"
          :limit="1"
          :on-exceed="handleExceed"
          :file-list="fileList"
          list-type="picture"
          style="width: 400px"
        >
          <el-button size="small" type="primary" plain>点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            <span style="margin-left: 10px">推荐尺寸: 370px * 260px</span>
            <span style="margin-left: 10px">只能上传jpg/png文件，且不超过500kb</span>
          </div>
        </el-upload>
      </el-form-item>

      <!-- 下载压缩包 -->
      <el-form-item label="* 压缩包下载">
        <el-input placeholder="请输入下载地址" v-model="form.zip_url" clearable show-word-limit></el-input>
      </el-form-item>

      <el-form-item label="当月推荐" required prop="new_state">
        <el-select v-model="form.new_state" clearable placeholder="请选择">
          <el-option
            v-for="item in newState"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物料类型">
        <el-select v-model="form.typeIds" @change="$forceUpdate()" multiple placeholder="请选择">
          <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="排序号:" required prop="sort_num">
        <el-input-number v-model="form.sort_num" :precision="2" :step="0.01"></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="back">取 消</el-button>
      <el-button size="small" type="primary" @click="submit('form')">确 定</el-button>
    </span>
  </div>
</template>

<script>
import uploadFile from "@/config/uploadFile";

import MarkDown from "@/components/markdown";
import { getAdminSubjectList } from "@/api/admin.js";

import {
  addBaseMeterial,
  materialList,
  sceneList
} from "@/api/operationalActivities.js";

export default {
  components: {
    MarkDown: MarkDown
  },
  data() {
    return {
      type: "",
      fileList: [],
      fileListqun: [],

      typeList: [],
      sceneList1: [],
      subjectList: [],
      showmarkdown: true,
      newState: [
        {
          value: "0",
          label: "不置顶"
        },
        {
          value: "1",
          label: "1级"
        },
        {
          value: "2",
          label: "2级"
        },
        {
          value: "3",
          label: "3级"
        },
        {
          value: "4",
          label: "4级"
        },

        {
          value: "5",
          label: "5级"
        },
        {
          value: "6",
          label: "6级"
        }
      ],
      typeIds1: [],
      typeIds2: [],

      form: {
        sort_num: "00.00",
        main_content: "",
        typeIds: []
      },
      rules: {
        scene_id: [
          { required: true, message: "请输选择场景", trigger: "change" }
        ],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],

        brief_content: [
          { required: true, message: "请输入简要介绍", trigger: "blur" }
        ],
        sort_num: [
          { required: true, message: "请输入排序号", trigger: "change" }
        ],
        main_content: [{ required: true, message: "请输入活动介绍" }]
      }
    };
  },
  // watch: {
  //   "form.typeIds"(val) {
  //     console.log(val);
  //     this.typeList = val;
  //   }
  // },

  created() {
    if (this.$route.query.row != null) {
      console.log(this.$route.query.act);
      this.form.main_content = JSON.parse(this.$route.query.row).main_content;
      console.log(JSON.parse(this.$route.query.row), 555555555555);
    }
  },
  mounted() {
    this.getinfo();
    this.getAdminSubjectList();
    this.materialList();
    this.sceneList();
  },
  methods: {
    getinfo() {
      this.type = this.$route.query.act;
      if (this.type != "add") {
        let a = [];
        // let b = [];
        this.form = JSON.parse(this.$route.query.row);
        console.log(this.form.typeNameArr, 456789);
        this.form.typeIds = [];
        a = JSON.parse(this.$route.query.row).typeNameArr;
        a.map(item => {
          this.form.typeIds.push(item.base_meterial_type_id);
        });
        console.log(this.form.typeIds);

        this.fileList.push({
          url: JSON.parse(this.$route.query.row).img_url
        });
        if (JSON.parse(this.$route.query.row).zip_url != null) {
          this.fileListqun.push({
            url: JSON.parse(this.$route.query.row).zip_url
          });
        }
        // this.fileListqun.push({
        //   url: JSON.parse(this.$route.query.row).zip_url
        // });

        if (JSON.parse(this.$route.query.row).new_state === 0) {
          this.form.new_state = "不置顶";
        }
        if (JSON.parse(this.$route.query.row).new_state === 1) {
          this.form.new_state = "1级";
        }
        if (JSON.parse(this.$route.query.row).new_state === 2) {
          this.form.new_state = "2级";
        }
        if (JSON.parse(this.$route.query.row).new_state === 3) {
          this.form.new_state = "3级";
        }
        if (JSON.parse(this.$route.query.row).new_state === 4) {
          this.form.new_state = "4级";
        }
        if (JSON.parse(this.$route.query.row).new_state === 5) {
          this.form.new_state = "5级";
        }
        if (JSON.parse(this.$route.query.row).new_state === 6) {
          this.form.new_state = "6级";
        }
      }
    },
    leixi(data) {
      console.log(data, 5555);
    },

    //添加编辑
    submit(form) {
      if (this.form.new_state === "不置顶") {
        this.form.new_state = 0;
      }
      if (this.form.new_state === "1级") {
        this.form.new_state = 1;
      }
      if (this.form.new_state === "2级") {
        this.form.new_state = 2;
      }
      if (this.form.new_state === "3级") {
        this.form.new_state = 3;
      }
      if (this.form.new_state === "4级") {
        this.form.new_state = 4;
      }
      if (this.form.new_state === "5级") {
        this.form.new_state = 5;
      }
      if (this.form.new_state === "6级") {
        this.form.new_state = 6;
      }

      console.log(this.fileList, 123);
      if (this.fileList.length === 0) {
        this.$message.warning("请上传图片");
      } else {
        this.$refs[form].validate(valid => {
          if (valid) {
            if (this.type === "add") {
              addBaseMeterial({
                typeIds: JSON.stringify(this.form.typeIds),
                scene_id: this.form.scene_id,

                // scene_id: this.form.scene_id,
                subject_id: this.form.subject_id,
                title: this.form.title,
                brief_content: this.form.brief_content,
                main_content: this.form.main_content,
                zip_url: this.form.zip_url,
                img_url: this.form.img_url,
                new_state: this.form.new_state,
                sort_num: this.form.sort_num
              }).then(res => {
                console.log(res);
                this.$message.success("创建课程成功!");
                this.$router.push({
                  path: "/background/basicMaterial"
                });
              });
            } else {
              addBaseMeterial({
                base_meterial_id: JSON.parse(this.$route.query.row).id,
                typeIds: JSON.stringify(this.form.typeIds),
                scene_id: this.form.scene_id,

                // scene_id: this.form.scene_id,
                subject_id: this.form.subject_id,
                title: this.form.title,
                brief_content: this.form.brief_content,
                main_content: this.form.main_content,
                zip_url: this.form.zip_url,
                img_url: this.form.img_url,
                new_state: this.form.new_state,
                sort_num: this.form.sort_num
              }).then(res => {
                console.log(res);
                this.$message.success("修改成功！");
                this.$router.push({
                  path: "/background/basicMaterial"
                });
              });
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    //获取物料标签
    materialList() {
      materialList().then(res => {
        this.typeList = res.baseMeterialTypeList;

        // this.sceneList = res.baseMeterialTypeList;
      });
    },
    //获取物料类型
    sceneList() {
      sceneList().then(res => {
        this.sceneList1 = res.baseMeterialSceneList;
      });
    },

    //获取科目
    getAdminSubjectList() {
      getAdminSubjectList({
        page_no: 1,
        page_size: 100
      }).then(res => {
        console.log(res);
        this.subjectList = res.subject_list;
      });
    },
    //录入
    SaveMarkDown(md, html) {
      console.log("保存markdown");
      console.log(md);
      console.log(html);

      this.form.main_content = md;
    },
    //课程封面
    uploadFile() {},
    async handleChangeFile(file, fileList) {
      console.log("handleChangeFile");
      console.log(fileList);

      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList);
      }
    },
    async uploadFileOss(list) {
      this.uploadFileTime = true;
      await uploadFile(list, this.$store.state.user.userInfo.code).then(res => {
        console.log("上传文件");
        console.log(res);
        res.map(item => {
          this.form.img_url = item.url;
        });
        this.fileList = res;
        this.uploadFileTime = false;
        this.rules.fileUpdate = [];
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },

    handleExceed() {
      this.$message.warning("请删除原有文件,再重新上传");
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.addTrainingCourseAdmin {
  height: 100%;
  min-height: 100vh;
  background-color: #fff;
  margin: 10px;
  padding: 15px;
  .form-style {
    margin-left: 15px;
  }
  .table-style {
    margin-top: 15px;
  }
}
</style>